import React, { useState, useEffect } from "react"
import {
  Card,
  Button,
  Input,
  Table,
  Select,
  Dropdown,
  Icon,
  Loader,
  Dimmer,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { apiGet, apiPost } from "../utils/apiConnector"
import { terminalApi, storeListApi } from "../config/apiUrls"
import { useDisptach, useSelector } from "react-redux"

const NewTerminal = (props) => {
  const { t } = useTranslation()
  const [name, setName] = useState("")
  const [mode, setMode] = useState("")
  const [line, setLine] = useState("")
  const [place, setPlace] = useState("")
  const [storage, setStorage] = useState("")
  const [lines, setLines] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const getLines = () => {
    setIsLoading(true)
    apiGet(storeListApi, {})
      .onOk((res) => {
        setLines(res.data.response)
        if (res.data.response.length) {
          setLine(res.data.response[0].id)
        }
      })
      .onFail(() => {})
      .afterAll(() => {
        setIsLoading(true)
      })
      .startSingle()
  }
  const { getTerminals } = props
  useEffect(() => {
    getLines()
    return () => {}
  }, [])
  return (
    <>
      <Dimmer active={isLoading} inverted>
        <Loader />
      </Dimmer>
      <div>
        <Card fluid>
          <Card.Content>
            <h3>
              <b>{t("New device")}</b>
            </h3>
            <div style={{ margin: 20 }}>
              <div>
                <div>{t("Name")}</div>
                <div>
                  <Input
                    value={name}
                    onChange={(e, d) => {
                      setName(d.value)
                    }}
                    size="small"
                    style={{ marginTop: 10, marginBottom: 10 }}
                  />
                </div>
              </div>
              <div style={{ display: "none" }}>
                <div>Режим работы устройства</div>
                <div>
                  <Input
                    value={mode}
                    onChange={(e, d) => {
                      setMode(d.value)
                    }}
                    size="small"
                    style={{ marginTop: 10, marginBottom: 10 }}
                  />
                </div>
              </div>
              <div>
                <div>{t("Line")}</div>
                <div>
                  <Select
                    value={line}
                    options={lines.map((q) => ({
                      key: q.id,
                      value: q.id,
                      text: q.name,
                    }))}
                    onChange={(e, d) => {
                      setLine(d.value)
                    }}
                    size="small"
                    style={{ marginTop: 10, marginBottom: 10 }}
                  />
                </div>
              </div>
              <div style={{ display: "none" }}>
                <div>Рабочее место</div>
                <div>
                  <Input
                    value={place}
                    type="number"
                    onChange={(e, d) => {
                      setPlace(d.value)
                    }}
                    size="small"
                    style={{ marginTop: 10, marginBottom: 10 }}
                  />
                </div>
              </div>
              <div style={{ display: "none" }}>
                <div>Склад</div>
                <div>
                  <Input
                    value={storage}
                    onChange={(e, d) => {
                      setStorage(d.value)
                    }}
                    size="small"
                    style={{ marginTop: 10, marginBottom: 10 }}
                  />
                </div>
              </div>
              <div>
                <Button
                  content={t("Save")}
                  positive
                  style={{ marginTop: 30 }}
                  onClick={() => {
                    const storeId = profile.stores.length
                      ? profile.stores[0].id
                      : 0
                    if (!storeId) return
                    const req = {}
                    req.storeId = storeId
                    if (name) {
                      req.name = name
                    }
                    if (mode) {
                      req.mode = mode
                    }
                    if (line) {
                      req.line = line
                    }
                    if (place) {
                      req.place = place
                    }
                    if (storage) {
                      req.storage = storage
                    }
                    apiPost(terminalApi, req)
                      .onOk(() => {})
                      .onFail(() => {})
                      .afterAll(() => {
                        getTerminals()
                      })
                      .startSingle()
                  }}
                />
              </div>
            </div>
          </Card.Content>
        </Card>
      </div>
    </>
  )
}

export default NewTerminal
